import { Button } from 'components/Button/Button'
import { templates } from 'components/FolderTemplatesDialog/Templates'
import { WorkflowTemplate } from 'components/FolderTemplatesDialog/Types'
import Styles from './CreateForm.module.scss'

interface Props {
  onSelect: (template: WorkflowTemplate) => void
}

export const TemplatesGrid = ({ onSelect }: Props) => (
  <div className={Styles.templatesGrid}>
    {templates.map((template) => (
      <Button key={template.id} variant="secondaryGrey" size="xl" onPress={() => onSelect(template)}>
        {template.emoji} {template.title()}
      </Button>
    ))}
  </div>
)
